/**
 * Mobile App Store Configuration
 * Centralized configuration for mobile app store URLs and IDs
 */
export const APP_STORE_CONFIG = {
  APPLE: {
    APP_ID: '6754383942',
    WEB_URL: 'https://apps.apple.com/us/app/qse-chat/id6754383942',
  },
  GOOGLE_PLAY: {
    PACKAGE_ID: 'com.qse.chat',
    WEB_URL: 'https://play.google.com/store/apps/details?id=com.qse.chat',
  },
} as const
